// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZeroCard_wrapper__yzMkW","card":"ZeroCard_card__LMMMl","cardRight":"ZeroCard_cardRight__2gbk9","cardLeft":"ZeroCard_cardLeft__3d0Kj"};